import { Document, Page, Text, View, Image, Font } from "@react-pdf/renderer";
import sitlogo from '../../assets/images/sitlogo.png';
import { IMG_URL } from '../BaseUrl';
import { formatDate } from '../../Utils/dateFormat';

Font.register({
  family: 'Poppins',
  fonts: [
    {
      src: '/fonts/Poppins-Regular.ttf',
      fontWeight: 'normal',
    },
    {
      src: '/fonts/Poppins-SemiBold.ttf',
      fontWeight: 600,
    },
    {
      src: '/fonts/Poppins-Bold.ttf',
      fontWeight: 'bold',
    },
  ],
});

const BatchWiseFacultyPayment = ({ data }) => {

  const facultyPayment = Array.isArray(data) ? data : [];
  const grandTotalHours = facultyPayment.reduce((acc, item) => acc + parseFloat(item.Total_Hours || 0), 0);
  const grandTotalAmount = facultyPayment.reduce((acc, item) => acc + parseFloat(item.Total_Amount || 0), 0);


  function formatDate(dateInput) {
    const date = new Date(dateInput);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }



  return (
    <Document>
      <Page size="A4" style={{ padding: 30, fontSize: 10, paddingLeft: 80 }}>
        <View style={{ textAlign: "left", width: '100%', height: "20px" }}>
          <Text style={{ fontSize: 9, fontWeight: 600, fontFamily: 'Poppins' }}>
            Suvidya Institute Of Techonology Pvt. Ltd
          </Text>
        </View>

        <View style={{ width: '100%', height: "24px", border: '1px solid black', flexDirection: 'row', paddingLeft: 100, paddingTop: 6 }}>
          <Text style={{ fontSize: 9, fontWeight: 600, fontFamily: 'Poppins' }}>Faculty Payment Details for Batch : </Text>
          <Text style={{ fontSize: 9, fontFamily: 'Poppins' }}>{facultyPayment[0]?.Batch_Code}</Text>
        </View>

        <View style={{ width: '100%', border: '1px solid black', borderBottom: 'none', flexDirection: 'column', marginTop: 30 }}>
          <View style={{ flexDirection: 'row', borderBottom: '1px solid black', width: '100%', height: "24px" }}>
            <View style={{ width: '6%', borderRight: '1px solid black', paddingTop: 8, alignItems: 'center' }}>
              <Text style={{ fontSize: 8, fontWeight: 600, fontFamily: 'Poppins' }}>S.No.</Text>
            </View>
            <View style={{ width: '26%', borderRight: '1px solid black', paddingTop: 8, alignItems: 'center' }}>
              <Text style={{ fontSize: 8, fontWeight: 600, fontFamily: 'Poppins' }}>Faculty Name</Text>
            </View>
            <View style={{ width: '22%', borderRight: '1px solid black', paddingTop: 8, alignItems: 'center' }}>
              <Text style={{ fontSize: 8, fontWeight: 600, fontFamily: 'Poppins' }}>Salary Structure</Text>
            </View>
            <View style={{ width: '14%', borderRight: '1px solid black', paddingTop: 8, alignItems: 'center' }}>
              <Text style={{ fontSize: 8, fontWeight: 600, fontFamily: 'Poppins' }}>Salary</Text>
            </View>
            <View style={{ width: '15%', borderRight: '1px solid black', paddingTop: 8, alignItems: 'center' }}>
              <Text style={{ fontSize: 8, fontWeight: 600, fontFamily: 'Poppins' }}>Total Duration</Text>
            </View>
            <View style={{ width: '17%', paddingTop: 8, alignItems: 'center' }}>
              <Text style={{ fontSize: 8, fontWeight: 600, fontFamily: 'Poppins' }}>Total_Salary</Text>
            </View>
          </View>

          {facultyPayment.map((item, index) => (
            <View key={index} style={{ flexDirection: 'row', borderBottom: '1px solid black', width: '100%', height: "22px" }}>
              <View style={{ width: '6%', borderRight: '1px solid black', alignItems: 'center', justifyContent: 'center' }}>
                <Text style={{ fontSize: 8, fontWeight: 600, fontFamily: 'Poppins' }}>{index + 1}</Text>
              </View>
              <View style={{ width: '26%', borderRight: '1px solid black', alignItems: 'center', justifyContent: 'center' }}>
                <Text style={{ fontSize: 8, fontWeight: 600, fontFamily: 'Poppins' }}>{item.Faculty_Name}</Text>
              </View>
              <View style={{ width: '22%', borderRight: '1px solid black', alignItems: 'center', justifyContent: 'center' }}>
                <Text style={{ fontSize: 8, fontWeight: 600, fontFamily: 'Poppins' }}>{item.Sal_Struct}</Text>
              </View>
              <View style={{ width: '14%', borderRight: '1px solid black', alignItems: 'center', justifyContent: 'center' }}>
                <Text style={{ fontSize: 8, fontWeight: 600, fontFamily: 'Poppins' }}>{item.Salary}</Text>
              </View>
              <View style={{ width: '15%', borderRight: '1px solid black', alignItems: 'center', justifyContent: 'center' }}>
                <Text style={{ fontSize: 8, fontWeight: 600, fontFamily: 'Poppins' }}>{item.Total_Hours}</Text>
              </View>
              <View style={{ width: '17%', alignItems: 'center', justifyContent: 'center' }}>
                <Text style={{ fontSize: 8, fontWeight: 600, fontFamily: 'Poppins' }}>{item.Total_Amount}</Text>
              </View>
            </View>
          ))}

          <View style={{ flexDirection: 'row', borderBottom: '1px solid black', width: '100%', height: "22px" }}>
            <View style={{ width: '68%', borderRight: '1px solid black', justifyContent: "center", paddingLeft: 220 }}>
              <Text style={{ fontSize: 8, fontWeight: 600, fontFamily: 'Poppins' }}>Grand Total</Text>
            </View>
            <View style={{ width: '15%', borderRight: '1px solid black', alignItems: 'center', justifyContent: 'center' }}>
              <Text style={{ fontSize: 8, fontWeight: 600, fontFamily: 'Poppins' }}>{grandTotalHours.toFixed(2)}</Text>
            </View>
            <View style={{ width: '17%', alignItems: 'center', justifyContent: 'center' }}>
              <Text style={{ fontSize: 8, fontWeight: 600, fontFamily: 'Poppins' }}>{grandTotalAmount.toFixed(2)}</Text>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default BatchWiseFacultyPayment;
